import React from 'react';

class SeatingplanView extends React.Component {
	componentDidMount() {

	}
	render() {
		return (
			<h1>{this.props.name} </h1>
		);
	}
}

export default SeatingplanView;
